import {
    DELETE_KYCCONFIGURATIONRECORD_SUCCESS,
    DELETE_KYCCONFIGURATIONRECORD_FAILED,
    RESET_DELETE_KYCCONFIGURATIONRECORD,
    LOADING_DELETE_KYCCONFIGURATIONRECORD,
    NETWORK_ERROR_DELETE_KYCCONFIGURATIONRECORD,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetDeleteKycConfigurationRecord = () => {
    return { type: RESET_DELETE_KYCCONFIGURATIONRECORD };
};

const deleteKycConfigurationRecord = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_DELETE_KYCCONFIGURATIONRECORD });
    await partnerServices
        .post("deleteKycConfigurationRecord", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(getKycConfigurationListSuccess(res.data));
                    break;
                default:
                    dispatch(getKycConfigurationListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_DELETE_KYCCONFIGURATIONRECORD,
                payload: err,
            });
        });
};
function getKycConfigurationListSuccess(data) {
    return {
        type: DELETE_KYCCONFIGURATIONRECORD_SUCCESS,
        payload: data,
    };
}
function getKycConfigurationListFailed(data) {
    return {
        type: DELETE_KYCCONFIGURATIONRECORD_FAILED,
        payload: data,
    };
}

export { resetDeleteKycConfigurationRecord, deleteKycConfigurationRecord };
